<template>
    <div class="xmgl_detail">
        <div class="sidebar-logo-container">
            <div class="head-left">
                <div>
                    <img src="/images/articleHeadLogo.png" style="margin-right: 10px; width: 44px" />
                </div>
                <div>
                    <div style="display: flex; align-items: center; position: relative; top: -5px">
                        <div class="sidebar-title" style="white-space: nowrap">
                            <!-- <svg-icon style="margin-right: 10px" icon-class="dcdb_kb_title" /> -->
                            <span>{{ logoTitle[0] }}</span>
                        </div>
                        <div class="sidebar-divide" />
                        <div class="sidebar_title_project">{{ logoTitle[1] }}</div>
                    </div>
                    <div class="formTapBtn">
                        <div class="tapItemBtn" :class="activeName === 'detail' ? 'active' : ''" @click="handleTabsClick('detail')">项目信息</div>
                        <div class="tapItemBtn" :class="activeName === 'sqlc' ? 'active' : ''" @click="handleTabsClick('sqlc')">申请流程</div>
                        <div class="tapItemBtn" :class="activeName === 'jggs' ? 'active' : ''" @click="handleTabsClick('jggs')">结果公示</div>
                        <div class="tapItemBtn" :class="activeName === 'xgzl' ? 'active' : ''" @click="handleTabsClick('xgzl')">相关资料</div>
                    </div>
                </div>
            </div>
            <div class="head-right">
                <el-button @click="close">
                    <svg-icon style="color: red; margin-right: 5px" icon-class="glyphicon-off" />
                    <span v-pageBtn-lbl="'close'">关 闭</span>
                </el-button>
            </div>
        </div>
        <div class="mainform-container">
            <div class="page-container">
                <div class="mainform-pagecontent">
                    <xmlx v-if="activeName === 'detail'" :vo="vo"></xmlx>
                    <sqlc v-if="activeName === 'sqlc'" :vo="vo" :wf-engine-url="wfEngineUrl"></sqlc>
                    <jggs v-if="activeName === 'jggs'" :vo="vo" :wf-engine-url="wfEngineUrl"></jggs>
                    <xgzl v-if="activeName === 'xgzl'" :vo="vo" :wf-engine-url="wfEngineUrl"></xgzl>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import xmlx from './components/xmlx'
import sqlc from './components/sqlc'
import jggs from './components/jggs'
import xgzl from './components/xgzl'
export default {
    components: {
        xmlx,
        sqlc,
        jggs,
        xgzl
    },
    props: {},
    data() {
        return {
            logoTitle: [],
            activeName: 'detail',
            vo: {},
            wfEngineUrl: ''
        }
    },
    computed: {},
    watch: {
        $route() {
            if (this.$route.query.documentTitle) {
                document.title = this.$route.query.documentTitle
            } else if (this.$route.query.logoTitle) {
                document.title = this.$route.query.logoTitle
            }
        }
    },
    created() {
        this.logoTitle = this.$route.query.logoTitle ? decodeURIComponent(this.$route.query.logoTitle).split('/') : []
        this.wfEngineUrl = this.$route.query.wfEngineUrl
        console.log(this.logoTitle, this, 'this')
    },
    beforeDestroy() {},
    mounted() {
        this.getdata()
    },
    methods: {
        handleTabsClick(tabName) {
            this.activeName = tabName
        },
        getdata() {
            this.$http({
                method: 'GET',
                contentType: 'application/x-www-form-urlencoded',
                params: { id: this.$route.query.busiDataId },
                url: this.$route.query.wfEngineUrl + '/getById'
            }).then(
                (response) => {
                    if (response.code === 'success') {
                        this.vo = response.body.vo
                    } else {
                        this.$message.error(response.message)
                    }
                },
                (err) => {
                    console.log(err)
                }
            )
        },
        close() {
            window.close()
        }
    }
}
</script>

<style scoped lang="scss">
@import '~@/wapp/common/styles/variables.module.scss';
.xmgl_xmzx_item {
    width: 22px;
    height: 22px;
    vertical-align: middle !important;
}

.xmgl_detail {
    background: #eff1f7;
    height: 100%;
    .xmgl_detail_content {
        padding: 10px;
        background: #eff1f7;
    }
    .sidebar-logo-container {
        background: #fff;
        height: 68px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 20px;
        .head-left {
            height: 68px;
            display: flex;
            align-items: center;
        }
        .head-right {
        }

        .sidebar-title {
            color: #333;
            font-weight: 400;
            line-height: 35px;
            font-size: 16px;
            align-items: center;
            display: flex;
            svg {
                font-size: 35px;
            }
        }
        .sidebar-divide {
            border-right: 1px solid #ccc;
            margin: 0 10px;
            height: 22px;
        }
        .sidebar_title_project {
            font-size: 14px;
            line-height: 28px;
            height: 28px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            color: #999;
        }
    }
}

.com {
    padding: 10px 0 0px 0;
}
.whiteBox {
    background: #fff;
}
/deep/.el-scrollbar__wrap {
    overflow-x: hidden;
}
.formTapBtn {
    position: relative;
    bottom: 0px;
    display: flex;
    left: 0;
    font-family: MicrosoftYaHei;
    color: #000000;
    font-size: 14px;
    width: 440px;
    .tapItemBtn {
        position: relative;
        margin-right: 15px;
    }
    .active {
        position: relative;
        color: var(--subjectColor);
        font-weight: bold;
        &::after {
            content: '';
            position: absolute;
            bottom: -10px;
            left: 0px;
            width: 100%;
            height: 2px;
            background: var(--subjectColor);
        }
    }
    .tapItemBtn:hover {
        cursor: pointer;
        color: var(--subjectColor);
    }
}
.mainform-container {
    .page-container {
        min-height: calc(100vh - 120px);
        background: #fff;
        position: relative;
        margin: 20px;
        .mainform-pagecontent {
            padding: 30px 122px;
            height: calc(100vh - 100px);
            overflow: auto;
        }
    }
}
@media (min-width: 1921px) and (max-width: 3839px) {
    .mainform-container-first {
        display: flex;
    }
    .wflow-container .mainform-container .page-container {
        // width: calc((100% - 60px) / var(--devicePixelRatio));
        width: calc(100% - 60px);
    }
    .wflow-container .mainform-have-sidebar {
        width: auto;
        flex: 1;
    }
    .wflow-container .mainform-sidebar {
        width: 15%;
        max-width: 15%;
    }
}
@media (min-width: 3840px) {
    .mainform-container-first {
        display: flex;
    }
    .wflow-container .mainform-container .page-container {
        width: 3200px;
    }
    .wflow-container .mainform-have-sidebar {
        width: auto;
        flex: 1;
    }
    .wflow-container .mainform-sidebar {
        width: 15%;
        max-width: 580px;
    }
}
</style>
